import PropTypes from "prop-types";
import React from "react";

export const DialogRow = React.forwardRef(
    ({ label, children, className = "", ...props }, ref) => (
        // Добавлен grid для работы col-span и обязательный пробел перед кастомным className
        <div 
            ref={ref} 
            className={`flex flex-col gap-2 w-full ${className}`} 
            {...props}
        >
            <div className="eyebrow">{label}</div>
            <div className="w-full">{children}</div>
        </div>
    )
);

// Помогает React DevTools правильно отображать имя компонента вместо "ForwardRef"
DialogRow.displayName = "DialogRow";

DialogRow.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string, // Лучше объявить в propTypes, раз он деструктурируется
};
